import { render, staticRenderFns } from "./AnnouncementCategory.vue?vue&type=template&id=79e36610"
import script from "./AnnouncementCategory.vue?vue&type=script&lang=js"
export * from "./AnnouncementCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports